
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ServiceCardProps {
  title: string;
  description: string;
  imageSrc: string;
  link: string;
}

const ServiceCard = ({ title, description, imageSrc, link }: ServiceCardProps) => {
  return (
    <Card className="overflow-hidden transition-all hover:shadow-md flex flex-col h-full">
      <div className="relative h-48 overflow-hidden">
        <img 
          src={imageSrc} 
          alt={title} 
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
      </div>
      <CardHeader>
        <CardTitle className="text-xl text-kaija-accent">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex-grow">
        <CardDescription className="text-gray-700">
          {description}
        </CardDescription>
      </CardContent>
      <CardFooter className="mt-auto">
        <Button asChild className="w-full bg-kaija-accent hover:bg-opacity-90 text-white">
          <Link to={link}>Loe rohkem</Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ServiceCard;
